import {
  RANGE_TIME,
  RANGE_TIME_EXTEND_TYPE,
  DATASOURCESIM,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const STATIC_FILTER_CONFIGS = {
  RANGE_TIME: {
    type: RANGE_TIME,
    key: RANGE_TIME,
    extendFilterType: RANGE_TIME_EXTEND_TYPE.singleDate,
    visible: 1,
    disabled: false,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  DATASOURCESIM: {
    key: DATASOURCESIM,
    default: [],
    singleType: 'single',
    isSearchItemMargin: true,
    isShowButtonLabel: true,
  },
};

export const DEFAULT_FORM_VALUE = {
  [RANGE_TIME]: {
    type: 'date',
    value: [],
  },
  [DATASOURCESIM]: {
    value: 'sensortower',
  },
};
